export class UnexpectedError extends Error {
  constructor() {
    super(
      "Unexpected Error. Check internet connection and try again.\n PrepaidPlus: 319 0468"
    );
    this.name = "UnexpectedError";
  }
}
